function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Image, Descriptions, Statistic, Table, Tag, Button, Drawer, Modal, notification, Space } from "antd";
import Moment from "react-moment";
import AddTicket from "../admin-forms/AddTickets";
import { NodePlusFill, PrinterFill } from "react-bootstrap-icons";
import TicketsList from "./TicketsList";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import Common from "../../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EventSummary = function EventSummary(_ref) {
  var event = _ref.event,
    refresh = _ref.refresh;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    totalSold = _useState2[0],
    setTotalSold = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    amountSold = _useState4[0],
    seetAmountSold = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    totalAv = _useState6[0],
    setTotalAv = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    ticketsList = _useState8[0],
    setTicketsList = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    usedList = _useState10[0],
    setUsedList = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showAddTickets = _useState12[0],
    setShowAddTickets = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedEvent = _useState14[0],
    setSelectedEvent = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showPrintTickets = _useState16[0],
    setShowPrintTickets = _useState16[1];
  var ref = useRef();
  var cols = [{
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Moment, {
          date: text,
          format: "DD/MM/YYYY HH:mm"
        })
      });
    }
  }, {
    title: "Type accès",
    dataIndex: "plan",
    key: "plan",
    render: function render(text) {
      return /*#__PURE__*/_jsx(Tag, {
        color: "geekblue",
        children: text
      });
    }
  }, {
    title: "Montant",
    dataIndex: "amount",
    key: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx(Tag, {
        color: "volcano",
        children: text.toLocaleString("Fr")
      });
    }
  }, {
    title: "Num.Ticket",
    dataIndex: "ticket_id",
    key: "ticket_id",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }];
  useEffect(function () {
    event.tickets.forEach(function (t) {
      setTotalAv(function (prev) {
        return prev + t.price_schema_item.price;
      });
      setTicketsList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          date: t.created_at,
          plan: t.price_schema_item.label,
          amount: t.price_schema_item.price,
          ticket_id: t.ticket_code
        }]);
      });
    });
    event.tickets.filter(function (t) {
      return t.status == 1;
    }).forEach(function (ti) {
      setTotalSold(function (prev) {
        return prev + ti.price_schema_item.price;
      });
      setUsedList(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          date: ti.created_at,
          plan: ti.price_schema_item.label,
          amount: ti.price_schema_item.price,
          ticket_id: ti.ticket_code
        }]);
      });
    });
    // axios.get(Common.baseApiUrl+"geteventsummary");
  }, [event, refresh]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Image, {
            src: event.image_file,
            width: "80px",
            height: "80px",
            style: {
              borderRadius: "80px"
            }
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Descriptions, {
            bordered: true,
            size: "small",
            title: /*#__PURE__*/_jsx("b", {
              children: "DETAILS EVENEMENT"
            }),
            column: 1,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "TITRE"
              }),
              children: event.label
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "DATE DEBUT"
              }),
              children: /*#__PURE__*/_jsx(Moment, {
                date: event.starts_at,
                format: "DD/MM/YYYY HH:mm"
              })
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "LIEU"
              }),
              children: event.place
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: /*#__PURE__*/_jsx("b", {
                children: "ACTION"
              }),
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: function onClick() {
                    setSelectedEvent(event);
                    setShowAddTickets(true);
                  },
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [" ", /*#__PURE__*/_jsx(NodePlusFill, {
                      size: 20
                    }), " AJOUTER DES TICKETS"]
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  style: {
                    background: "#2F789F"
                  },
                  onClick: function onClick() {
                    setSelectedEvent(event);
                    setShowPrintTickets(true);
                  },
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [" ", /*#__PURE__*/_jsx(PrinterFill, {
                      size: 20
                    }), " APERCU"]
                  })
                })]
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#EEE",
                  padding: "20px",
                  borderRadius: "7px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Total Tickets"
                  }),
                  value: event.tickets.length.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#EEE",
                  padding: "20px",
                  borderRadius: "7px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Montant total tickets"
                  }),
                  value: totalAv.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#EEE",
                  padding: "20px",
                  borderRadius: "7px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Total tickets utilis\xE9s"
                  }),
                  value: usedList.length.toLocaleString("Fr")
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 6,
              sm: 12,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#EEE",
                  padding: "20px",
                  borderRadius: "7px"
                },
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: /*#__PURE__*/_jsx("b", {
                    children: "Montant tickets utilis\xE9s"
                  }),
                  value: totalSold.toLocaleString("Fr")
                })
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), event.price_schema_items.map(function (s) {
            return /*#__PURE__*/_jsxs(Row, {
              style: {
                marginBottom: "10px"
              },
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 6,
                sm: 12,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    background: "#EEE",
                    padding: "20px",
                    borderRadius: "7px"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsxs("b", {
                      children: ["Total ", s.label]
                    }),
                    value: s.tickets.length.toLocaleString("Fr")
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 6,
                sm: 12,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    background: "#EEE",
                    padding: "20px",
                    borderRadius: "7px"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsxs("b", {
                      children: ["Montant ", s.label]
                    }),
                    value: (s.tickets.length * s.price).toLocaleString("Fr")
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 6,
                sm: 12,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    background: "#EEE",
                    padding: "20px",
                    borderRadius: "7px"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsxs("b", {
                      children: ["Total utilis\xE9s ", s.label]
                    }),
                    value: s.tickets.filter(function (it) {
                      return it.status == 1;
                    }).length.toLocaleString("Fr")
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 3,
                md: 6,
                sm: 12,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    background: "#EEE",
                    padding: "20px",
                    borderRadius: "7px"
                  },
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: /*#__PURE__*/_jsxs("b", {
                      children: ["Montant utilis\xE9s ", s.label, " "]
                    }),
                    value: (s.tickets.filter(function (it) {
                      return it.status == 1;
                    }).length * s.price).toLocaleString("Fr")
                  })
                })
              })]
            }, s.id);
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
            bordered: true,
            dataSource: ticketsList,
            columns: cols,
            pagination: true
          })]
        })
      })
    }), selectedEvent && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: "AJOUTER TICKETS",
        onCancel: function onCancel() {
          setShowAddTickets(false);
        },
        open: showAddTickets,
        destroyOnClose: true,
        width: "650px",
        footer: null,
        children: /*#__PURE__*/_jsx(AddTicket, {
          event: selectedEvent,
          handler: function handler() {
            refresh();
            setShowAddTickets(false);
            notification.success({
              message: "Ok!",
              description: "Opération réussie!"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "IMPRESSION"
        }),
        onClose: function onClose() {
          setShowPrintTickets(false);
        },
        open: showPrintTickets,
        destroyOnClose: true,
        width: "95%",
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx(TicketsList, {
          design: 4,
          tickets: selectedEvent.tickets,
          ref: ref
        })
      })]
    })]
  });
};
export default EventSummary;